import { Card, Divider, Icon, Link } from '@nike/eds';
import { useMemo } from 'react';
import { Link as RouterLink, useLoaderData } from 'react-router-dom';
import './App.css';
import { decodeJwt } from './utils/authHelpers';

function App() {
  const loaderData = useLoaderData() as { access_token: string };
  const jwt = loaderData.access_token;
  const claim = decodeJwt(jwt);
  const authorizedMenu = useMemo(() => {
    const userScopes: string[] = claim.scp || [];
    return {
      tokenizerAllowed: true,
      pwAllowed: true,
      dictionaryAllowed: userScopes.includes('search360:dictionary:read'),
      rewriteAllowed: userScopes.includes('search360:rewrite:read'),
      nicknameAllowed: userScopes.includes('search360:nickname:read'),
      searchopsAllowed: userScopes.includes('search360:searchops:read'),
      searchopsWriteAllowed: userScopes.includes('search360:searchops:write'),
    };
  }, [claim.scp]);
  return (
    <div className='tw-flex tw-items-center tw-justify-center tw-h-full'>
      <div className='tw-flex tw-justify-center tw-items-stretch tw-gap-2 tw-flex-wrap'>
        <Card className='tw-basis-1/2 md:tw-basis-1/3 hover:tw-bg-gray-300 hover:tw-text-white app-menu-card'>
          <header>
            <div className='eds-type--display-5 tw-py-2'>
              Query Tokenization
            </div>
          </header>
          <Divider />
          <ul className='tw-text-left tw-mt-2'>
            <li className='tw-flex tw-items-center'>
              <div className='tw-mr-2'>
                <Icon
                  name='Discover'
                  size='m'
                  enableFocus
                  className='app-menu-icon'
                />
              </div>
              <Link
                as={RouterLink}
                to='/playground/tokenizer'
                font='body-1'
                className='app-menu-link'
              >
                Tokenizer playground
              </Link>
            </li>
            {authorizedMenu.dictionaryAllowed && (
              <li className='tw-flex tw-items-center'>
                <div className='tw-mr-2'>
                  <Icon
                    name='Journal'
                    size='m'
                    enableFocus
                    className='app-menu-icon'
                  />
                </div>
                <Link
                  as={RouterLink}
                  to='/dictionaries/nike-custom'
                  font='body-1'
                  className='app-menu-link'
                >
                  Nike custom dictionary
                </Link>
              </li>
            )}
          </ul>
        </Card>
        {authorizedMenu.rewriteAllowed && (
          <Card className='tw-basis-1/2 md:tw-basis-1/3 app-menu-card hover:tw-text-white hover:tw-bg-gray-300'>
            <header>
              <div className='eds-type--display-5 tw-py-2'>KTC Matching</div>
            </header>
            <Divider />
            <ul className='tw-text-left tw-mt-2'>
              {authorizedMenu.rewriteAllowed && (
                <li className='tw-flex tw-items-center'>
                  <div className='tw-mr-2'>
                    <Icon
                      name='Edit'
                      size='m'
                      enableFocus
                      className='app-menu-icon'
                    />
                  </div>
                  <Link
                    as={RouterLink}
                    to='/rewrite/list'
                    font='body-1'
                    className='app-menu-link'
                  >
                    Query rewrite
                  </Link>
                </li>
              )}
            </ul>
          </Card>
        )}
        <Card className='tw-basis-1/2 md:tw-basis-1/3 app-menu-card hover:tw-text-white hover:tw-bg-gray-300'>
          <header>
            <div className='eds-type--display-5 tw-py-2'>Search Playground</div>
          </header>
          <Divider />
          <ul className='tw-text-left tw-mt-2'>
            <li className='tw-flex tw-items-center'>
              <div className='tw-mr-2'>
                <Icon
                  name='Discover'
                  size='m'
                  enableFocus
                  className='app-menu-icon'
                />
              </div>
              <Link
                as={RouterLink}
                to='/playground/new-product-wall'
                font='body-1'
                className='app-menu-link'
              >
                New Product Wall
              </Link>
            </li>
          </ul>
        </Card>
        {authorizedMenu.nicknameAllowed && (
          <Card className='tw-basis-1/2 md:tw-basis-1/3 app-menu-card hover:tw-text-white hover:tw-bg-gray-300'>
            <header>
              <div className='eds-type--display-5 tw-py-2'>
                Product Nickname
              </div>
            </header>
            <Divider />
            <ul className='tw-text-left tw-mt-2'>
              <li className='tw-flex tw-items-center'>
                <div className='tw-mr-2'>
                  <Icon
                    name='FirstAccess'
                    size='m'
                    enableFocus
                    className='app-menu-icon'
                  />
                </div>
                <Link
                  as={RouterLink}
                  to='/nickname/list'
                  font='body-1'
                  className='app-menu-link'
                >
                  Nickname management
                </Link>
              </li>
            </ul>
          </Card>
        )}
        {authorizedMenu.searchopsAllowed && (
          <Card className='tw-basis-1/2 md:tw-basis-1/3 app-menu-card hover:tw-text-white hover:tw-bg-gray-300'>
            <header>
              <div className='eds-type--display-5 tw-py-2'>Search Ops</div>
            </header>
            <Divider />
            <ul className='tw-text-left tw-mt-2'>
              <li className='tw-flex tw-items-center'>
                <div className='tw-mr-2'>
                  <Icon
                    name='Settings'
                    size='m'
                    enableFocus
                    className='app-menu-icon'
                  />
                </div>
                <Link
                  as={RouterLink}
                  to='/searchops/query-console'
                  font='body-1'
                  className='app-menu-link'
                >
                  Query Console
                </Link>
              </li>
              {authorizedMenu.searchopsWriteAllowed && (
                <li className='tw-flex tw-items-center'>
                  <div className='tw-mr-2'>
                    <Icon
                      name='Repeat'
                      size='m'
                      enableFocus
                      className='app-menu-icon'
                    />
                  </div>
                  <Link
                    as={RouterLink}
                    to='/searchops/force-update'
                    font='body-1'
                    className='app-menu-link'
                  >
                    Force Update
                  </Link>
                </li>
              )}
            </ul>
          </Card>
        )}
      </div>
    </div>
  );
}

export default App;
